/**
 * 邮箱^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$
 * @param value
 * @param callback
 */
export const isEmail = (value) => {
    const patrn = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/;
    if (value && !patrn.test(value)) {
        return false
    } else {
        return true
    }
};